<div class="activities-container">
  <!-- Tabs: Assets | Compute (optional) | User action (when showTabs is true) -->
  @if (showTabs) {
    <div class="activities__tabs-row">
      <div class="activities__tabs">
        <button
          type="button"
          class="activities__tab"
          [class.activities__tab--active]="activeLogType === 'ASSET'"
          (click)="setLogType('ASSET')"
        >
          Assets
        </button>
        @if (!hideComputeTab && !hideComputeTabForDelegate) {
          <button
            type="button"
            class="activities__tab"
            [class.activities__tab--active]="activeLogType === 'COMPUTE'"
            (click)="setLogType('COMPUTE')"
          >
            Compute
          </button>
        }
        <button
          type="button"
          class="activities__tab"
          [class.activities__tab--active]="activeLogType === 'USER_ACTION'"
          (click)="setLogType('USER_ACTION')"
        >
          User action
        </button>
      </div>

      @if (showExportButton) {
        <button
          type="button"
          class="toolbar-export-btn"
          aria-label="Export table"
          (click)="onExport()"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path
              d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
            />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
          <span>Export</span>
        </button>
      }
    </div>
  }

  <!-- Filter Section (Compute tab: no Asset Type, Activity options = start/delete/open/create/stop only) -->
  @if (showFilters) {
    <app-filter-panel
      [fields]="effectiveFilterFields"
      [defaultExpanded]="false"
      (filterChange)="onFilterChange($event)"
      (clearFilters)="onClearFilters()"
    ></app-filter-panel>
  }

  <!-- Table -->
  <app-table
    [columns]="columns"
    [data]="activitiesData"
    [scrollHeight]="'400px'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    [showExportButton]="showExportButton && !showTabs"
    (export)="onExport()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (sortChange)="onSortChange($event)"
  >
    <!-- Custom Activity Column with Left Border Accent -->
    <ng-template #activityCell let-row>
      <div [class]="'activity-cell ' + getActivityClass(row.activity)">
        <span class="activity-text" [attr.title]="row.activity">{{
          row.activity
        }}</span>
      </div>
    </ng-template>
  </app-table>
</div>
